<div animate.enter="fade-in" animate.leave="fade-out" class="lgt-loader-overlay" [ngClass]="overlayClass()">
  <div class="lgt-loader-container d-flex align-items-center flex-column justify-content-center">
    <mat-spinner [diameter]="sizes[size()]"></mat-spinner>
    @if (overlayLabel()) {
      <label class="m-t-6 lgt-loader-overlay-label caption-white body2">
        {{ overlayLabel() }}
      </label>
    }
  </div>
</div>
